import React from 'react';
import { Checkbox as CheckboxAK } from '@atlaskit/checkbox';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { type OptionProps, components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import type { CheckboxData } from '../types';
import messages from './messages';

type CheckboxOptionProps = OptionProps & {
	data: CheckboxData;
};

export const CheckboxOption = (props: CheckboxOptionProps) => {
	const {
		data: { id, title, description, isChecked, isDisabled },
	} = props;
	const { formatMessage } = useIntl();

	return (
		<components.Option {...props}>
			<Tooltip content={isDisabled ? formatMessage(messages.tooltipRoleDisabled) : null}>
				<Flex
					direction="row"
					gap="space.025"
					key={`roles-${id}`}
					testId={`users-and-roles.common.ui.roles-picker.options.checkbox.${id}`}
				>
					<CheckboxAK tabIndex={-1} isChecked={isChecked} isDisabled={isDisabled} />
					<Flex direction="column">
						<Box xcss={titleStyles}>{title}</Box>
						<Box xcss={[descriptionStyles, isDisabled && descriptionDisabledStyles]}>
							{description}
						</Box>
					</Flex>
				</Flex>
			</Tooltip>
		</components.Option>
	);
};

const titleStyles = xcss({
	font: token('font.body'),
	fontWeight: token('font.weight.medium'),
	paddingBottom: 'space.050',
	lineHeight: token('space.300'),
	wordBreak: 'break-word',
});

const descriptionStyles = xcss({
	font: token('font.body.UNSAFE_small'),
	wordBreak: 'break-word',
	color: 'color.text.subtlest',
});

const descriptionDisabledStyles = xcss({
	color: 'color.text.disabled',
});
